// Шапка экранов после оформления (макеты «3D-модель», «Статус», «Мои заказы»): «назад»,
// название страницы и логотип. В Mini App «назад» — кнопка Telegram.
import { useNavigate } from "react-router";
import { useIsMiniApp } from "../telegram/channel";
import { useTelegramBackButton } from "../telegram/useBackButton";
import { IconButton } from "./Button";
import { Logo } from "./Logo";
import styles from "./PageHeader.module.css";

export function PageHeader({ title, backTo, gift = false }: { title: string; backTo?: string; gift?: boolean }) {
  const isMiniApp = useIsMiniApp();
  const navigate = useNavigate();
  useTelegramBackButton(backTo === undefined ? null : () => navigate(backTo));
  const showBack = backTo !== undefined && !isMiniApp;
  return (
    <header className={[styles.header, showBack ? "" : styles.noBack].join(" ")}>
      {showBack && <IconButton icon="back" label="Назад" to={backTo} />}
      <span className={styles.title}>{title}</span>
      <Logo gift={gift} />
    </header>
  );
}

const DAY_MONTH = new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long" });

// «Заказ от 17 октября».
export function orderDateTitle(createdAt: string): string {
  return `Заказ от ${DAY_MONTH.format(new Date(createdAt))}`;
}
